'use strict'

module.exports =
  getValidPageNumber: (pageNumber) ->
    pageNumber = parseInt(pageNumber)
    return 1 if isNaN(pageNumber) or pageNumber < 1
    pageNumber

  getPageBlockForPageNumber: (pageNumber, numPagesPerBlock) ->
    Math.floor((pageNumber - 1) / numPagesPerBlock)

  isSamePageBlock: (priorPageNumber, currentPageNumber, numPagesPerBlock) ->
    @getPageBlockForPageNumber(priorPageNumber, numPagesPerBlock) is @getPageBlockForPageNumber(currentPageNumber, numPagesPerBlock)
